module.exports = __webpack_public_path__ + "img/linkedin.42524ed9.svg";